export interface IRevisionHistory {
  id: number;
  country: string;
  dealerName: string;
  dealerAddress: string;
  dealerCode: number;
  kilometers: number;
  revisionCode: number;
  revisionDate: string;
  revisionName: string;
  serviceOrder: number | string;
  user: string;
  vin: string;
  months: number;
}
